import { PackageTypeList } from "@/resources/packages/PackageTypeList";

/** Bets — packages of `package_type='bet'` over the unified `/api/packages`. */
export function BetList() {
  return (
    <PackageTypeList
      resource="bets"
      packageType="bet"
      title="Bets"
      description="Strategic bets that prioritize which contours and skills to invest in."
      emptyMessage="No bets yet."
    />
  );
}

export default BetList;
